import { Box, IconButton, Modal, Typography } from '@mui/material';
import closeIcon from '../../../assets/MyAccountIcon/close-icon.svg';
import './GenderPreferenceModal.css';
import { useState } from 'react';
import { axiosInstance } from '../../../utils/tokenUtils';
import { toast } from 'react-hot-toast';
import { useTranslation } from '../../../i18n/LanguageContext';
import GenderMaleIcon from '../../../assets/MyAccountIcon/male-gender-image.png';
import GenderFemaleIcon from '../../../assets/MyAccountIcon/female-gender-image.png';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

const GenderPreferenceModal = ({
  openGenderPreferenceModal,
  setOpenGenderPreferenceModal,
  teacherProfileDetails,
  onUpdated,
}) => {
  const { translate } = useTranslation();
  const [genderPreference, setGenderPreference] = useState(
    teacherProfileDetails?.gender_preference || 'open_to_all'
  );

  const handleClose = () => {
    setOpenGenderPreferenceModal(false);
  };

  const handleGenderSelect = gender => {
    setGenderPreference(gender);
  };

  const getGenderOptionClass = gender => {
    return `gender-option-container ${genderPreference === gender ? 'active-gender-option-container' : ''}`;
  };

  const handleSave = async e => {
    e.preventDefault();

    try {
      const response = await axiosInstance.patch('/teachers', {
        gender_preference: genderPreference,
      });

      if (response.status === 200) {
        toast.success(`${translate('myAccount', 'genderPreferenceSuccessMessageText')}`);
        if (typeof onUpdated === 'function') {
          onUpdated();
        }
        handleClose();
      }
    } catch (error) {
      console.log(error);
      toast.error(`${translate('myAccount', 'genderPreferenceFailedMessageText')}`);
    }
  };

  return (
    <Modal
      open={openGenderPreferenceModal}
      // onClose={handleClose}
    >
      <Box sx={style}>
        <Box className="password-modal-container">
          <Box className="password-modal-header">
            <Typography className="modal-title">
              {translate('myAccount', 'genderPreferenceModalText')}
            </Typography>
            <IconButton onClick={handleClose}>
              <img src={closeIcon || '/placeholder.svg'} alt="close" />
            </IconButton>
          </Box>
          <Box className="flex flex-col gap-4">
            <Typography className="gender-preference-message-text">
              {translate('myAccount', 'selectGenderText')}
            </Typography>
            <Box className="flex items-center gap-2">
              <Box
                className={getGenderOptionClass('male')}
                onClick={() => handleGenderSelect('male')}
              >
                <img src={GenderMaleIcon} alt="gender" />
                <div>{translate('myAccount', 'maleText')}</div>
              </Box>
              <Box
                className={getGenderOptionClass('female')}
                onClick={() => handleGenderSelect('female')}
              >
                <img src={GenderFemaleIcon} alt="gender" />
                <div>{translate('myAccount', 'femaleText')}</div>
              </Box>
              <Box
                className={getGenderOptionClass('open_to_all')}
                onClick={() => handleGenderSelect('open_to_all')}
              >
                <div>{translate('myAccount', 'bothText')}</div>
              </Box>
            </Box>
            <Typography className="gender-preference-message-text">
              {translate('myAccount', 'haveSelectedText')}{' '}
              {genderPreference === 'male'
                ? `${translate('myAccount', 'maleText')}`
                : genderPreference === 'female'
                  ? `${translate('myAccount', 'femaleText')}`
                  : `${translate('myAccount', 'bothText')}`}{' '}
              {translate('myAccount', 'preferredStudentText')}
            </Typography>
          </Box>
          <Box className="password-modal-footer">
            <button className="cancel-button-gender" onClick={handleClose}>
              {translate('myAccount', 'cancelButtonText')}
            </button>
            <button className="save-button-gender" onClick={handleSave}>
              {translate('myAccount', 'confirmText')}
            </button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default GenderPreferenceModal;
